module.exports = __webpack_public_path__ + "img/jifen.33cc2035.png";